import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { isAuthenticated } from "../../auth/helper/auth";
import { API } from "../../backend";
import CourseCard from "../../components/CourseCard";
import AuthPopup from "../../components/Popups/AuthPopup";
import { CourseT } from "../../types/model";
import { getHttpHandler } from "../../utils/httpHandler";
import "./Home.css";

const Home = () => {
  const location: any = useLocation();
  const [welcomeMessage, setWelcomeMessage] = useState<boolean>(false);
  const [courses, setCourses] = useState<CourseT[]>([]);
  const [courseLoading, setCourseLoading] = useState<boolean>(false);
  const [authShow, setAuthShow] = useState<boolean>(false);

  const getAllCourses = async () => {
    setCourseLoading(true);
    try {
      const allCourses: CourseT[] = await getHttpHandler({
        url: `${API}/courses`,
      });
      setCourses(allCourses);
      setCourseLoading(false);
    } catch (error) {
      setCourseLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCourses();
    if (location?.state?.loggedIn) {
      setTimeout(() => {
        setWelcomeMessage(true);
        setTimeout(() => {
          setWelcomeMessage(false);
        }, 5000);
      }, 2000);
    }
  }, []);

  return (
    <div className="home">
      <AuthPopup
        show={authShow}
        setShow={setAuthShow}
        title={"Enroll for this course"}
        description={"Please log in to enroll in this course"}
      />
      {welcomeMessage && isAuthenticated()?.user?.name && (
        <h4 className="welcomeMessage">
          Welcome {isAuthenticated()?.user?.name} to iNeuron Courses
        </h4>
      )}
      <div className="home-container">
        {courseLoading ? (
          <Spinner animation="border" />
        ) : (
          courses?.length > 0 &&
          courses?.map((course) => (
            <CourseCard
              course={course}
              setCourses={setCourses}
              setAuthShow={setAuthShow}
              key={course._id}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Home;
